<div [innerHTML]="htmlContent" (click)="params?.isInnerHtmlContentClick ? onClick(params): ''" class="px-2 text-primary text-truncate f-12 mb-0 font-regular">
  
</div>
